<div class="file-button">
    <input class="file-input" type="file" #fileUpload>
    <button mat-button mat-raised-button color="primary" (click)="onFileSelect($event)">{{text}}</button>
</div>